import block from '@/mixins/block'

export default {
  name: 'block_quote',
  mixins: [block],
  data () {
    return {
      // bgc: {
      //   backgroundColor: this.data.color
      // },
      needIntersection: true
    }
  },
  mounted () {
    this.$el._show = this.show.bind(this)
    this.$el._hide = this.hide.bind(this)

    // if (this.data.color !== "#FFFFFF") {
    //   this.$el.classList.add('color')
    // }

    setTimeout(() => {
      this.lineSplit()
    }, 1000)
  },
  methods: {
    lineSplit () {
      this.splited = new SplitText(this.$el.querySelector('.block-quote-citation'), { type: 'lines' })
      this.$nextTick(() => {
        this.lines = this.$el.querySelectorAll('.block-quote-citation > div')
        for (let i = 0; i < this.lines.length; i++) {
          const line = this.lines[i]
          line.classList.add('block-quote-citation-line-wrapper')
          line.innerHTML =
            `<span class="block-quote-citation-line" style="transition-delay: ${i * (1 / (this.lines.length * 3))}s">` +
            line.innerHTML +
            `</span>`
        }
      })
    },
    show () {
      this.$el.classList.remove('hidden')
      setTimeout(() => {
        this.splited.revert()
      }, 2000)
    },
    hide () {

    }
  }
}
